import './SideMenu.css'
import { Component, useEffect, useState } from 'react'

class SideMenu extends Component{

  constructor(props){
    super(props);
    this.state = { notes: props.notes}
  }
 
  static getDerivedStateFromProps(nextProps, prevState){
    return {notes: nextProps.notes}
  }

  updateMenu = (notes)=>{
    this.setState({notes : notes})
  }

  render(){
    return (
      <div className='sidemenu-container'>
        {this.state.notes.map((note) => {
          return (
            <div
              key={note.id}
              id={(this.props.selectedNote && this.props.selectedNote.id == note.id) ? 'selected' : ''}
              className='note-item w3-panel w3-green w3-card'
              onClick={() => this.props.changeSelectedNote(note)}
            >
              <div className='note-title'>{note.title}</div>
              <div className='note-text' dangerouslySetInnerHTML={{ __html: note.text }}></div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default SideMenu
